import type { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import {
  getInitialRegistrationDates,
  persistRegistrationDates,
} from "./registrationTrackingDateUtils";

export function usePersistedRegistrationDateRange(
  organizationId: string | undefined,
) {
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(() =>
    organizationId
      ? getInitialRegistrationDates(organizationId).dateFrom
      : null,
  );
  const [dateTo, setDateTo] = useState<Dayjs | null>(() =>
    organizationId
      ? getInitialRegistrationDates(organizationId).dateTo
      : null,
  );

  useEffect(() => {
    if (!organizationId) {
      setDateFrom(null);
      setDateTo(null);
      return;
    }
    const { dateFrom: from, dateTo: to } =
      getInitialRegistrationDates(organizationId);
    setDateFrom(from);
    setDateTo(to);
  }, [organizationId]);

  useEffect(() => {
    if (!organizationId || !dateFrom || !dateTo) return;
    persistRegistrationDates(organizationId, dateFrom, dateTo);
  }, [organizationId, dateFrom, dateTo]);

  return { dateFrom, setDateFrom, dateTo, setDateTo };
}
